
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-382dbf98&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HelpCenterCopyrightManagement.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HelpCenterCopyrightManagement.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-382dbf98!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HelpCenterCopyrightManagement.vue"),
  /* scopeId */
  "data-v-382dbf98",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/helpCenter/HelpCenterCopyrightManagement.vue
// module id = 555
// module chunks = 0